import React, { useEffect, useState } from "react";
import CustomImageComponent from "./CustomImageComponent";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 200) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    isVisible && (
      <a
        href="#"
        className="scrolltop-btn"
        style={{ display: "inline" }}
        onClick={(e) => {
          e.preventDefault(); // Prevent any default behavior
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}
      >
        <CustomImageComponent src={"/assets/img/scrolltop-arrow.svg"} alt={"scrolltop-icon"} />
      </a>
    )
  );
};

export default ScrollToTop;
